import { UploadData } from '../../../../store/uploadStore';
import { UploadNotRestoredError } from '../../../../errors/UploadNotRestoredError';
import { mapUploadTypeToMetricsEntityType } from '../../../../libs/metrics/metricUtils';
import { Point } from '@influxdata/influxdb-client-browser';
import { influxWriter } from '../../../../libs/metrics/InfluxWriter';

const validationTimers = new Map<object, number>();

export const trackValidationStart = (upload: UploadData) => {
  // upload.queue is a stable object
  const key = upload.queue;

  if (!validationTimers.has(key)) {
    validationTimers.set(key, Date.now());
  }
};

// @TODO
// Our UI allows to add a few photos at a time, so this will lead to multiple "short" validations of the same site
// if the queue is cleared before the user adds more photos (or during interruptions)
// Do we care about this? Should we use 5 minute timeout windows here etc?
export const sendValidationTimeSeconds = (upload: UploadData) => {
  if (!upload.upload) throw new UploadNotRestoredError();

  const key = upload.queue;

  if (validationTimers.has(key)) {
    const startTime = validationTimers.get(key)!;
    const validationTime = Date.now() - startTime;

    validationTimers.delete(key);

    if (validationTime) {
      const point = new Point();
      point.tag('Customer', upload.upload.customer);
      point.tag('Site', upload.upload.site);
      point.tag('EntityType', mapUploadTypeToMetricsEntityType(upload.meta.type));

      point.floatField('value', Math.round(validationTime / 1000));

      influxWriter.send('ValidationTimeSeconds', point);
    }
  }
};
